import { httpClient, metaGen } from "./_http"

// DOC -> https://qalocation.carrierglobe.com/swagger-ui.html

// 文件上传
export const uploadFile = (payload) => {
  const meta = metaGen()
  return httpClient.post("/file/upload", {
    meta,
    params: payload
  })
}

// 文件查询
export const queryFileById = (payload) => {
  const meta = metaGen()
  return httpClient.post("/file/uploadid/query", {
    meta,
    params: payload
  })
}

// 文件上传 水印
export const uploadFileAddWaterMark = (payload) => {
  return httpClient.post("/duckBill/application/addWaterMark", payload)
}



// WEBPACK FOOTER //
// ./src/api/file.js